import { useEffect, useState } from "react";
import api from "@/lib/api";
import { TID } from "@/constants/testIds";
import { EvidenceChip } from "@/components/common/EvidenceChip";
import { Link } from "react-router-dom";

const CATEGORY_LABEL = {
  onboarding: "Onboarding", product: "Product", learning: "Learning", assessment: "Assessment",
  support: "Support", complaint: "Complaint", recommendation: "Recommendation",
  profile_update: "Profile Update", consent: "Consent", communication: "Communication",
};

const CATEGORIES = ["all", "onboarding", "learning", "assessment", "support", "complaint", "recommendation", "consent", "communication"];

export default function TimelinePage() {
  const [events, setEvents] = useState([]);
  const [cat, setCat] = useState("all");
  useEffect(() => { api.get("/timeline").then(r => setEvents(r.data)); }, []);
  const filtered = cat === "all" ? events : events.filter(e => e.category === cat);

  return (
    <div data-testid={TID.timelinePage} className="space-y-6 animate-fade-in-up">
      <header className="flex items-end justify-between border-b border-border pb-4">
        <div>
          <div className="text-[10px] uppercase tracking-[0.22em] text-altara-teal font-semibold">Timeline</div>
          <h1 className="font-display text-3xl font-semibold tracking-tight text-altara-ink mt-1">Tenant-wide event stream</h1>
          <p className="text-sm text-muted-foreground mt-1">Every institutional interaction becomes an event, and every event updates the Consumer Intelligence Profile.</p>
        </div>
        <div className="font-mono text-[10px] text-muted-foreground">{filtered.length} events</div>
      </header>

      <div className="flex flex-wrap gap-1.5">
        {CATEGORIES.map(c => (
          <button
            key={c}
            onClick={() => setCat(c)}
            className={`px-2.5 py-1 text-[10px] uppercase tracking-[0.15em] rounded-sm border ${
              cat === c ? "bg-altara-deep text-white border-altara-deep" : "bg-white text-slate-600 border-slate-200 hover:border-altara-deep"
            }`}
          >
            {c === "all" ? "All" : (CATEGORY_LABEL[c] || c)}
          </button>
        ))}
      </div>

      <div className="border border-slate-200 rounded-sm overflow-hidden bg-white">
        <table className="w-full text-xs">
          <thead className="bg-slate-50 text-[10px] uppercase tracking-[0.15em] text-slate-500">
            <tr>
              <th className="text-left px-4 py-2 font-medium">When</th>
              <th className="text-left px-4 py-2 font-medium">Category</th>
              <th className="text-left px-4 py-2 font-medium">Event</th>
              <th className="text-left px-4 py-2 font-medium">Source</th>
              <th className="text-left px-4 py-2 font-medium">Evidence</th>
              <th className="text-left px-4 py-2 font-medium">Consumer</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map(e => (
              <tr key={e.event_id} className="border-t border-slate-100 hover:bg-slate-50/60">
                <td className="px-4 py-2 font-mono text-[10px] text-slate-500">{new Date(e.occurred_at).toLocaleString()}</td>
                <td className="px-4 py-2"><span className="text-[10px] uppercase tracking-[0.15em] bg-slate-50 border border-slate-200 px-1.5 py-0.5 rounded-sm">{CATEGORY_LABEL[e.category] || e.category}</span></td>
                <td className="px-4 py-2">
                  <div className="font-medium text-slate-800">{e.title}</div>
                  <div className="text-[10px] text-slate-500">{e.description}</div>
                </td>
                <td className="px-4 py-2 text-slate-600">{e.source_system}</td>
                <td className="px-4 py-2">
                  <div className="flex flex-wrap gap-1">
                    {(e.evidence_ids || []).slice(0, 3).map(id => <EvidenceChip key={id} id={id} />)}
                  </div>
                </td>
                <td className="px-4 py-2">
                  <Link to={`/consumers/${e.consumer_id}`} className="font-mono text-[10px] text-altara-teal hover:text-altara-deep">
                    {e.consumer_id.slice(0, 12)}…
                  </Link>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && <tr><td colSpan={6} className="px-4 py-8 text-center text-slate-400">No events for this filter.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
